/* rxlib - Button v2.0.0 */

import Spinner from "../../spinner";

export type ButtonType = "button" | "submit";
export type ButtonClassStyle = "btn-rxlib" | "btn-primary" | "btn-secondary" | "btn-success" | "btn-danger" | "btn-warning" | "btn-info" | "btn-light" | "btn-dark";

export interface ButtonProps {
    texto: string;
    type: ButtonType;
    className?: string;
    disabled?: boolean;
    carregando?: boolean;
    onClick?: () => void;
    fontAwesomeIcon?: string;
    classNameDivSpinner?: string;
    classStyle: ButtonClassStyle;
}

export default function Button({
    texto,
    onClick,
    className,
    carregando,
    type = "button",
    fontAwesomeIcon,
    disabled = false,
    classNameDivSpinner,
    classStyle = "btn-rxlib",
}: ButtonProps) {
    let classNameButton: string = "btn btn-block rxlib-btn " + classStyle;
    if ((className) && (className !== "")) {
        classNameButton = className + " " + classNameButton;
    }

    return (
        <>
            {
                (carregando)
                    ? <Spinner
                        classStyle="rxlib-spinner"
                        classNameDiv={classNameDivSpinner} />
                    : <button type={type} onClick={onClick} className={classNameButton} disabled={disabled}>
                        {
                            (fontAwesomeIcon)
                                ? <i className={fontAwesomeIcon}></i>
                                : texto
                        }
                    </button>
            }
        </>
    );
}